//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//translate
import { useTranslation } from 'react-i18next';

//type
import { carBookingType } from '../../api/Cars/type/CarsType';

//mui
import { Button, CircularProgress, DialogProps, TextField } from '@mui/material';

interface Props {
    callFunction: (data: any, id?: number) => Promise<any>
    loading: boolean
    setCloseDialog: (value: {open:boolean,scrollType: DialogProps['scroll']}) => void
    reCallfetchApi: (currentTimeFilter?: string, currentStatus?: string) => Promise<any>
    setData: (data: any[]) => void
    selectedCar?: carBookingType
    setSelectedCar?: (selectedCar: carBookingType | null) => void
    id?: number
    comment?: string
    timeFilter?: string
    status?: string
    setPage?: (page: number) => void
    claim_id?: number
}

const AddClaims = ({callFunction, loading, setCloseDialog, setData, reCallfetchApi, selectedCar, setSelectedCar, id, comment, timeFilter, status, setPage, claim_id}: Props) => {
    const {t} = useTranslation()
    const AddClaimsSchema = Yup.object().shape({
        comment: Yup.string()
            .trim()
            .min(5, t("comment_must_be_at_least_5_characters"))
            .required(t("comment_is_required")),
    });

    // start functions

    const handleAddClaims = async (values: any)=>{
        let result
        if(values.booking_id === null) {
            delete values.booking_id
        }
        if(selectedCar) {
            result = await callFunction(values);
        }
        else {
            result = await callFunction(values, claim_id);
        }
        if(result.code === 200) {
            setSelectedCar?.(null);
            setCloseDialog({open:false, scrollType: "paper"});
            setPage?.(1)
            let result = await reCallfetchApi?.(timeFilter, status);
            setData(result.data);
        }
    }

    // end functions
    
    return (
    <div>
        <Formik
        initialValues={{
            booking_id: id || null, 
            comment: comment || ""
        }}
        validationSchema={AddClaimsSchema}
        onSubmit={(values)=>handleAddClaims(values)}
        >
            {({ values,touched, errors,setFieldValue, setFieldTouched}) => (
                <Form>
                    <div className='mt-2'>
                        <div className='flex flex-col gap-10'>
                            <Field
                            as={TextField}
                            name="comment"
                            label={t("comment")}
                            className="w-full"
                            helperText={touched.comment && errors.comment ? errors.comment : ""}
                            error={touched.comment && Boolean(errors.comment)}
                            multiline
                            rows={6}              
                            />
                        </div>
                    </div>
                    <div className='mt-5 flex justify-center'>
                        <Button 
                        className={`h-[45px] ${selectedCar?.car?.fuel_type === "electric" ? "!bg-electricColor" : "!bg-paretnerColor"} !text-white !rounded-full`} type="submit">
                            {loading 
                            ? <CircularProgress className='w-1 h-1'/>
                            :t("confirm")
                            }
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    </div>
    )
}

export default AddClaims